export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Categoría\",\n    \"label_other\": \"{{count}} categorías\"\n}\n"